/**
 * Smart search: who has their tokens written off by site_server (and earns +50
 * «Обучение» for each chosen question or search — owner 03.10, «сделать как в
 * описании»). The pages read it through questionsQuotaApi; it lives here so the
 * points sheet (shared/ui ScoreHowTo) can say what is actually paid.
 *
 * "off" — everybody as before (the browser writes the token off, no points for
 * a choice); "admins" — real admins only, to check on prod first; "all" —
 * everyone. site_server has its own switch (SUP_SPEND_AWARD, default "admins");
 * a page that asks while the server says "disabled" falls back to the browser
 * debit, so the site may go to "all" first and the server after it.
 *
 * ⚠ RU (torsunov.life, `rus` branches) keeps "off": its wallet lives in Yandex,
 * not in the R2 bucket site_server debits. Set it there if main is ever merged.
 */
export type SupServerSpend = "off" | "admins" | "all";
export const SUP_SERVER_SPEND = "all" as SupServerSpend;

export const supServerSpendOn = (isRealAdmin: boolean): boolean =>
    SUP_SERVER_SPEND === "all" || (SUP_SERVER_SPEND === "admins" && isRealAdmin);
